import React from 'react';

export function StepFinishLabel() {
  return <>Závěr</>;
}
